<!-- snapshot -->
@if (isSnapshotAvailable) {
<av-tooltip [position]="tooltipPosition" message="Snapshot">
  <button
    [attr.aria-label]="'Take snapshot' | translate"
    avButton
    [raised]="true"
    ofType="icon"
    size="xs"
    color="basic"
    (click)="snapshot()"
    data-tid="point-controls/snapshot"
  >
    <av-icon name="camera"></av-icon>
  </button>
</av-tooltip>
} @if (isFreezeFrameAvailable) {
<av-tooltip [position]="tooltipPosition" message="Freeze video">
  <button
    [attr.aria-label]="'Freeze video' | translate"
    avButton
    [raised]="true"
    ofType="icon"
    size="xs"
    [color]="isFrameFrozen ? 'accent' : 'basic'"
    (click)="freezeFrame()"
    data-tid="point-controls/freeze-frame"
  >
    <av-icon name="snowflake"></av-icon>
  </button>
</av-tooltip>
} @if (isFreezeFrameAvailable) {
<av-tooltip [position]="tooltipPosition" message="Zoom in">
  <button
    avButton
    [raised]="true"
    [attr.aria-label]="'Zoom in' | translate"
    [disabled]="!isFrameFrozen"
    ofType="icon"
    size="xs"
    [color]="isZoomOn ? 'accent' : 'basic'"
    (click)="zoom()"
    data-tid="point-controls/zoom"
  >
    <av-icon name="zoom-in"></av-icon>
  </button>
</av-tooltip>
}

<!-- pointer -->
<av-tooltip [position]="tooltipPosition" message="Pointer">
  <button
    [attr.aria-label]="
      (isPointerActive ? '' : 'Enable') + ' ' + 'AR pointer' | translate
    "
    avButton
    [raised]="true"
    ofType="icon"
    size="xs"
    [color]="isPointerActive ? 'accent' : 'basic'"
    (click)="pointer()"
    data-tid="point-controls/pointer"
  >
    <av-icon name="laser"></av-icon>
  </button>
</av-tooltip>

<div
  class="tile-info tile-info-colors tile-info-colors-local"
  [attr.aria-label]="'Color' | translate"
>
  <av-tooltip [position]="column() ? 'left' : 'top'" message="Color">
    <button
      avButton
      [raised]="true"
      ofType="icon"
      size="xs"
      [color]="'basic'"
      (click)="isColorPickerOpen.set(!isColorPickerOpen())"
      data-tid="point-controls/color"
    >
      <app-point-color [color]="color()"></app-point-color>
    </button>
  </av-tooltip>
  @if (isColorPickerOpen()) {
  <av-card
    [popup]="true"
    [backdrop]="false"
    vAlign="bottom"
    hAlign="center"
    arrow="top"
  >
    <av-card-body size="sm">
      @for (c of colors(); track c) {
      <app-point-color
        [color]="c"
        (click)="changeColor(c)"
        [class.active]="c === color()"
        [class.disabled]="isColorDisabled(c) && c !== color()"
      ></app-point-color>
      }
    </av-card-body>
  </av-card>
  }
</div>
